export const editor = {
  post: null, // Current edited post
  contentType: "image-post",
  disabled: false,
  components: [], // Hold all the components that currently in the editor for submit validation
  componentMethods: [],
}
